import React from 'react'
import PropTypes from 'prop-types'

import routes from 'src/lib/rails-routes/rails-routes'
import List from 'src/ui/List/List'
import UnitListItem from 'src/pages/MyCourse/subcomponents/UnitListItem/UnitListItem'
import ToggledStateLabel from 'src/ui/ToggledStateLabel/ToggledStateLabel'
import { t } from 'src/lib/i18n-react'
import { usePageParams } from 'src/utils/params'

import TopicHeader from './subcomponents/TopicHeader/TopicHeader'
import TopicDetailSkeleton from './TopicDetailSkeleton'

const TopicDetail = ({
  topic,
  units,
  inCourse,
  unitsInCourseValuesMap,
  onToggleInCourse,
}) => {
  const { l2Code } = usePageParams()

  return (
    <TopicDetailSkeleton
      topicSection={
        <TopicHeader
          name={topic.name}
          description={topic.description}
          coverImageUrl={topic.coverImageUrl}
          isCompleted={units.every((unit) => unit.progress?.isCompleted)}
          inCourse={inCourse}
          onToggleInCourse={onToggleInCourse}
        />
      }
      listSection={
        <List
          title={t(
            '%{smart_count} Unit included |||| Units included (%{smart_count})',
            { smart_count: units.length }
          )}
          items={units}
          getItemUrl={(item) => routes.advanced_unit(l2Code, item.id)}
          itemIconShape="rounded"
          ItemState={(unit) =>
            unitsInCourseValuesMap[unit.id] ? (
              <ToggledStateLabel
                icon="bookmarked"
                label={t('Added to course')}
                labelDisplay={{ _: 'none', tablet: 'inline' }}
                ml={{ _: '1x', tablet: 0 }}
              />
            ) : (
              ' '
            )
          }
          ItemComponent={UnitListItem}
        />
      }
    />
  )
}

TopicDetail.propTypes = {
  topic: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    coverImageUrl: PropTypes.string,
  }).isRequired,
  inCourse: PropTypes.bool.isRequired,
  unitsInCourseValuesMap: PropTypes.object.isRequired,
  onToggleInCourse: PropTypes.func.isRequired,
  units: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      iconUrl: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default TopicDetail
